import { FC, useState, useEffect } from 'react';
import { createPortal } from 'react-dom';
import { LocalThemeContextProvider, useLocalThemeContext } from '../context';

export const Portal: FC<{ children: React.ReactNode }> = ({ children }) => {
  const theme = useLocalThemeContext();
  const [portalElement, setPortalElement] = useState<HTMLElement | null>(null);

  useEffect(() => {
    let portalDiv = document.getElementById('portal');

    if (!portalDiv) {
      portalDiv = document.createElement('div');
      portalDiv.setAttribute('id', 'portal');
      document.body.appendChild(portalDiv);
    }

    setPortalElement(portalDiv);
  }, []);

  if (!portalElement) return null;

  return createPortal(<LocalThemeContextProvider {...theme}>{children}</LocalThemeContextProvider>, portalElement);
};
